import { useEffect } from "react";
import { useGet } from "../../Hooks/useFetch";
import { getddmmyyyyFormat } from "../../Helpers/Helper";
import { ViewIcon } from "../Icons";
import DataLoader from "../DataLoader";
import WestpacPayment from "../WestpacPayment";
import AlertMessage from "../AlertMessage";
import "react-native-get-random-values";
import { v4 as uuidv4 } from "uuid";

const RecVesselPaymentList = ({ regoNo, isRenewAble }) => {
  const [res, err, isLoading, apiGet, abt] = useGet();

  useEffect(() => {
    apiGet("/api/pcraft/PcCraftPayments/" + regoNo);
  }, []);

  // console.log(res);

  return (
    <div className="recvessel-sub-container">
      <div className="recvessel-title-group">
        <h3 className="recvessel-title">Payment History</h3>
        {isRenewAble === true && (
          <WestpacPayment url={"/api/pcraft/RenewData/" + regoNo} />
        )}
      </div>

      {!isLoading ? (
        !err ? (
          res?.length === 0 ? (
            <AlertMessage
              message="No Records"
              level="info"
              closeEvt="false"
              mt="0"
              mb="0"
            />
          ) : (
            res?.map((d) => (
              <>
                <div className="row" key={uuidv4()}>
                  <div className="col-md-5">
                    <div className="recvessel-input-group">
                      <label htmlFor="">Date Paid</label>
                      <div className="recvesselInfoField">
                        {getddmmyyyyFormat(d?.pyDate?.split("T")[0])}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="recvessel-input-group">
                      <label htmlFor="">Amount</label>
                      <div className="recvesselInfoField">
                        {Math.abs(d?.pyAmt).toFixed(2)}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="recvessel-input-group">
                      <label htmlFor="Action">Action</label>
                      <div className="recvessel-input-group">
                        <div className="icon-group">
                          <ViewIcon
                            url={
                              "/recvessel/recvesselpaymentdetails/" +
                              regoNo +
                              "/" +
                              d.pySequNo
                            }
                            HoverCaption="View Payment History"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))
          )
        ) : (
          <AlertMessage message={err} />
        )
      ) : (
        <div className="dataLoader-container">
          <DataLoader isLoading={isLoading} />
        </div>
      )}
    </div>
  );
};

export default RecVesselPaymentList;
